import styled from 'styled-components'

export const Container = styled.div`
  height: 15em !important;
  width: 100% !important;
  zoom: 123% !important;
  margin-left: 15px !important;
`

export const TooltipWrapper = styled.div`
  min-width: 315px;
  padding: 0.625em 0.625em 0.625em 0.625em !important;
  border-radius: 0.3125em !important;
  background-color: ${({ theme }) => `${theme.cor53}e0`}!important;
  color: ${({ theme }) => theme.cor54}!important;
  border: 1px solid ${({ theme }) => theme.cor59}!important;
`

export const TooltipContent = styled.div`
  display: grid;
  gap: 4px;
`

export const TituloTooltip = styled.h1`
  font-weight: 600;
  font-size: 14px;
`

export const TextTooltip = styled.span`
  font-weight: 500;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const SemDados = styled.div`
  height: 305px;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-size: 20px;
  color: ${({ theme }) => theme.cor63}!important;
`

export const Elipse = styled.img`
  display: flex;
  height: 9px;
  width: 9px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.cor11};
`

export const ElipseWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`

export const PlanWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin-left: 13px;
`

export const Percentual = styled.span`
  color: ${({ theme }) => theme.cor66}!important;
`
